import { call, put, takeLatest } from 'redux-saga/effects'
import { getUserInfo } from '../api'
import { userInfoFetchFailed, userInfoFetchSucceeded } from '../actions/appSettings'
import { USER_INFO_FETCH_REQUESTED } from '../constants'

export function* fetchUserInfo(action = null) {
  try {
    const { data: userInfo } = yield call(getUserInfo)
    // Create a dict {cspCountryKey: csp} and an ordered list of cspCountryKeys
    userInfo.cspsByCspCountryKey = {}
    userInfo.cspCountryKeys = userInfo.csps.map(csp => {
      userInfo.cspsByCspCountryKey[csp.csp_country_key] = csp
      return csp.csp_country_key
    })
    yield put(userInfoFetchSucceeded(userInfo))
  } catch (error) {
    yield put(userInfoFetchFailed(error))
  }
}

export function* watchUserInfoFetchRequested() {
  yield takeLatest(USER_INFO_FETCH_REQUESTED, fetchUserInfo)
}
